import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import zhCommon from "./zh-CN/common.json";
import zhManagement from "./zh-CN/management.json";
import enCommon from "./en-US/common.json";
import enManagement from "./en-US/management.json";

function detectLanguage(): string {
  const stored = localStorage.getItem("agents-web:lang");
  if (stored) return stored;
  const nav = navigator.language;
  if (nav.startsWith("zh")) return "zh-CN";
  return "en-US";
}

i18n.use(initReactI18next).init({
  resources: {
    "zh-CN": { common: zhCommon, management: zhManagement },
    "en-US": { common: enCommon, management: enManagement },
  },
  lng: detectLanguage(),
  fallbackLng: "en-US",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;

export function setLanguage(lang: string) {
  localStorage.setItem("agents-web:lang", lang);
  i18n.changeLanguage(lang);
}
